import { EntryPaymentStatusEnum } from "generated/graphql";

export default function paymentStatusToLabel(status: EntryPaymentStatusEnum) {
    if (status === EntryPaymentStatusEnum.ClaimFiled) return 'Claim Filed'
    if (status === EntryPaymentStatusEnum.MarkedDoneByUser) return 'Marked Done By User'
    if (status === EntryPaymentStatusEnum.Paid) return 'Paid'
    if (status === EntryPaymentStatusEnum.PaidIncorrectly) return 'Paid Incorrectly'
    if (status === EntryPaymentStatusEnum.Unpaid) return 'Unpaid'
    return status
}